import { Container } from '@/components';
import React from 'react';
import Upload from './Upload';
import SalesFileTable from './SalesFileTable';

const UploadETA = () => {
  return (
    <Container title={'Upload Sales File'}>
      <div>
        <Upload />
      </div>
      <div className="mx-24">
        <SalesFileTable />
      </div>
    </Container>
  );
};

export default UploadETA;
